var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-tasks"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-center"
  }, [(_vm.selectedStates.indexOf('scheduled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('scheduled')
      }
    }
  }, [_vm._v("plánovaní")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "scheduled",
      "data-testid": "client-tasks-filter-scheduled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('scheduled'), 1)
      }
    }
  }, [_vm._v("plánovaní")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "completed",
      "data-testid": "client-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("splněno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "completed",
      "data-testid": "client-tasks-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("splněno")]), _vm._v(" "), (_vm.selectedStates.indexOf('canceled') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "client-tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('canceled')
      }
    }
  }, [_vm._v("zrušeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "client-tasks-filter-canceled"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('canceled'), 1)
      }
    }
  }, [_vm._v("zrušeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-tasks-refresh"
    },
    on: {
      "click": _vm.updateVisits
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-success",
    attrs: {
      "data-testid": "client-task-add-open"
    },
    on: {
      "click": _vm.showModalClientTaskAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" naplánovat úkol")])])])]), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'client-task-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(_vm.hasRole('receptionist')) ? _c('visit-task-change-state-receptionist', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client-task"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : (_vm.hasRole('doctor')) ? _c('visit-task-change-state-doctor', {
      attrs: {
        "actual-state": visit.state,
        "selected-doctor-id": visit.planned_for.id,
        "visit-id": visit.id,
        "test-prefix": "client-task"
      },
      on: {
        "update": _vm.updateVisits
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      attrs: {
        "data-testid": 'client-task-detail-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.hasLoggedUserRole('doctor')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ShowVisit',
          params: {
            clientid: _vm.$route.params.clientid,
            visitid: visit.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(visit.date) + "\n                        ")]) : [_vm._v("\n                            " + _vm._s(visit.date) + "\n                        ")]], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 col-sm-10 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note",
        "data-testid": 'client-task-note-' + visit.id
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "data-testid": 'client-task-save-' + visit.id
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'client-task-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [(visit.state === 'scheduled') ? [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.cancelVisitTask(visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-times-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" zrušit návštěvu")])] : _vm._e(), _c('br'), _vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        "), (visit.planned_by && visit.planned_at) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
          placement: 'bottom-center',
          classes: ['info']
        }),
        expression: "{\n                              content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,\n                              placement: 'bottom-center',\n                              classes: ['info']}"
      }],
      staticClass: "text-info fa fa-lg fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()], 2)]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? [_vm._l((diagnose.actions), function(action) {
        return [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                        " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                    ")])]), _vm._v(" "), (action.zulp.length > 0) ? _vm._l((action.zulp), function(zulp) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zulp: " + _vm._s(zulp.amount) + "x " + _vm._s(zulp.medicine.label) + "\n                                                        ")])])
        }) : _vm._e(), _vm._v(" "), (action.zum.length > 0) ? _vm._l((action.zum), function(zum) {
          return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                               zum: " + _vm._s(zum.amount) + "x " + _vm._s(zum.material.label) + "\n                                                        ")])])
        }) : _vm._e()]
      })] : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(1, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "card-body"
  }, [_vm._m(3)]), _vm._v(" "), _c('client-task-add', {
    attrs: {
      "opened": _vm.modalAddVisitOpened
    },
    on: {
      "update": _vm.updateVisits
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (na tento den není nic naplánováno)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68563142","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientTask.vue
// module id = 664
// module chunks = 0